import React from 'react';
import {ScrollView, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import DiscreteProgressListItem from '../DiscreteProgressListItem';

import {styles} from './DiscreteProgressListItem.style';

storiesOf('base', module).add('DiscreteProgressListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Discrete Progress List Item</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'DiscreteProgressListItem'}</Code> is based off the{' '}
          <Code>{'ListItem'}</Code> component and returns a list item with
          discrete progress using a hollow checkbox.
        </Text>
        <Spacer size={16} />
        <Text>
          The <Code>{'DiscreteProgressListItem'}</Code> accepts a{' '}
          <Code>{'label'}</Code>, <Code>{'currentCount'}</Code> and{' '}
          <Code>{'targetCount'}</Code> props.
        </Text>
      </Spacing>
    </FlexView>
    <View style={styles.wrapper}>
      <Gutter>
        <DiscreteProgressListItem
          label="Months into Rank"
          currentCount={1}
          targetCount={3}
          readonly
        />
      </Gutter>
    </View>
    <Spacer size={16} />
    <FlexView>
      <Gutter>
        <Code>{'label="Months into Rank"'}</Code>
        <Code>{'currentCount={1}'}</Code>
        <Code>{'targetCount={3)'}</Code>
        <Code>{'readonly'}</Code>
      </Gutter>
    </FlexView>
  </ScrollView>
));
